import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { UserService } from '../services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { UUID } from 'angular2-uuid';
import { ValidationMessages } from '../validation-messages';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', '../../assets/fcss/bootstrap.css', '../../assets/fcss/default.css', '../../assets/fcss/AdminLTE.css', '../../assets/fcss/_all-skins.css']
})
export class HomeComponent implements OnInit, AfterViewInit {
  activeMenu: any;
  loggedStatus: any;
  loggedUserName: any;
  loggedUserDName: any;
  loggedUserRole: any;
  loggedUserId: any;

  loginForm: UntypedFormGroup;
  submitted = false;
  loginError = false;
  loginErrorMsg = 'Invalid login credentials.';
  loginUserName: any;
  loginPassword: any;
  loginRemberMe: any;
  domainname: any = '';

 
  constructor(public router: Router, private formBuilder: UntypedFormBuilder, public userService: UserService, private spinner: NgxSpinnerService, public dataService: DataService) { }

  get f() { return this.loginForm.controls; }

  ngOnInit() {
    var domain = location.hostname + (location.port ? ':' + location.port : '');
    if (domain == ValidationMessages.stagingNormandyDomain || domain == ValidationMessages.productionNormandyDomain || domain == ValidationMessages.stagingCanopyDomain || domain == ValidationMessages.productionCanopyDomain || domain == ValidationMessages.stagingPbibinsDomain  || domain == ValidationMessages.productionPbibinsDomain) {
      $('.modal-header').addClass('normandy_login_header_bg');
    }
    else {
      $('.modal-header').addClass('login_header_bg');
    }



    let uuidValue = UUID.UUID();
    let uuidFValue = uuidValue.replace(/\-/g, '');
    localStorage.setItem('loggedInMbId', uuidFValue);

    window.scroll(0, 0);
    this.loginUserName = localStorage.getItem('loginUserName');
    this.loginPassword = localStorage.getItem('loginPassword');
    this.loginRemberMe = localStorage.getItem('loginRememberme');

    $('#myModalLabel').focus();
    $('.navbar-static-top').css('padding-bottom', '0');
    this.loggedUserDName = localStorage.getItem('u_name');
    this.loggedUserName = localStorage.getItem('u_email');
    this.loggedUserRole = localStorage.getItem('u_ur_id');
    this.loggedUserId = localStorage.getItem('u_id');

    this.loginForm = this.formBuilder.group({
      u_email: ['', Validators.required],
      u_password: ['', Validators.required]
    });

    setTimeout(() => {
      this.loginUserName = localStorage.getItem('loginUserName');
      this.loginPassword = localStorage.getItem('loginPassword');
      this.loginRemberMe = localStorage.getItem('loginRememberme');
      if (localStorage.getItem('loginRememberme') == '1') {
        this.loginForm.patchValue({
          u_email: this.loginUserName,
          u_password: this.loginPassword
        });
        $('.checkbox1').prop('checked', true);
      }
    }, 300);

    localStorage.setItem('active_tab', '1');
    this.dataService.changeCurrentHeaderActive('1');
    this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
    this.router.navigate(['/quotes']);
    if (this.loggedUserRole == 1 || this.loggedUserRole == 2) {
      this.router.navigate(['/quotes']);
    } else {
      this.goToQuotes();
    }
  }

  goToQuotes() {
    if (this.loggedUserName == localStorage.getItem('u_email')) {
      localStorage.setItem('active_tab', '2');
      this.dataService.changeCurrentHeaderActive('2');
      this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
      if (this.loggedUserRole == 3) {
        localStorage.setItem('brokerViewId', this.loggedUserId);
       
        if(localStorage.getItem('wholesalebroker') == '1' || localStorage.getItem('canhaveUserBroker') == '1' || localStorage.getItem('checkDisplayQuotes') == '1'){
          this.router.navigate(['/wbroker-quotes']);
        }else{
          this.router.navigate(['/broker-quotes']);
        }
      } else {
        this.router.navigate(['/quotes']);
      }
    } else {
      localStorage.setItem('active_tab', '1');
      this.dataService.changeCurrentHeaderActive('1');
      if (typeof localStorage.getItem('u_id') != 'undefined' && localStorage.getItem('u_id') != null && localStorage.getItem('u_id') != 'null' && localStorage.getItem('u_id') != "") {
        this.router.navigate(['/home']);
      } else {
      
      }
    }
  }

  ngAfterViewInit() {
    if (typeof localStorage.getItem('signUpValue') != undefined && localStorage.getItem('signUpValue') != "" && localStorage.getItem('signUpValue') != null) {
      localStorage.removeItem('signUpValue');
      document.getElementById('loginModalId').click();
    }
  }



  getAQuote() {
    localStorage.setItem('active_tab', '100');
    this.dataService.changeCurrentHeaderActive('100');
    this.router.navigate(['/newquote']);
  }

  goToOurstaff() {
    this.router.navigate(['/ourstaff']);
  }


  saveLoginInfo() {
    this.loginError = false;
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    this.submitted = false;
    var postData = {};
    postData = this.loginForm.value;
    postData['type'] = 2;
    postData['token_unique_id'] = localStorage.getItem('loggedInMbId');
    this.spinner.show();
    this.userService.userOperations(postData).subscribe(data => {
      this.checkUserData(data);
    });
  }

  goToSignUp() {
    this.loginError = false;
    this.submitted = false;
    this.loginForm.reset();

    this.router.navigate(['/signup']);
  
  }

  openForgotModal() {
    this.loginError = false;
    this.submitted = false;
    this.loginForm.reset();

  }

  resetFormValues() {
    this.loginError = false;
    this.submitted = false;
    this.loginForm.reset();
  }

  checkUserData(userInfo: any) {
    if (userInfo.output == 0) {
      this.loginError = true;
      if ( userInfo.u_status == 2 ){
        this.loginErrorMsg = 'New but cannot logon.';
      }
      else if(userInfo.u_status == 12 ){
        this.loginErrorMsg = 'Rater is under maintenance, please try login later.';
      }
      else if ( userInfo.u_status == 6 || userInfo.u_status == 4 ){
        this.loginErrorMsg = 'Account is suspended, please contact admin.';
      }
      else{
        this.loginErrorMsg = 'Invalid login credentials.';
      }

    } else {
      localStorage.setItem('loggedUserToken', userInfo.token);
      localStorage.setItem('PMAXLoggedIn', '0');
      localStorage.setItem('insuredAutoSave', '0');
      localStorage.setItem('insuredTabForm', JSON.stringify({}));
      localStorage.setItem('userLoggedInLoad', '1');
      localStorage.setItem('u_id', userInfo.userData.u_id);

      if(userInfo.isLroAdmin != undefined && userInfo.isLroAdmin != null && userInfo.isLroAdmin == 1){
        localStorage.setItem('u_lro_admin', '1');
      }

      localStorage.setItem('u_agent_broker', userInfo.userData.u_agent_broker);
      localStorage.setItem('u_user_broker', userInfo.userData.u_user_broker);
      if (userInfo.wholeselar == 1) {
        localStorage.setItem('u_ur_id', '3');
        localStorage.setItem('PMAXLoggedIn', '1');
      } else if (userInfo.userData.u_agent_broker == 1) {
        localStorage.setItem('u_ur_id', '3');
        localStorage.setItem('PMAXLoggedIn', '1');
      } else if (userInfo.userData.u_ur_id == 5) {
        localStorage.setItem('u_ur_id', '3');
        localStorage.setItem('PMAXLoggedIn', '1');
      } else if (userInfo.userData.u_ur_id == 6) {
        localStorage.setItem('u_ur_id', '3');
      } else {
        localStorage.setItem('u_ur_id', userInfo.userData.u_ur_id);
      }
     
      localStorage.setItem('checkDisplayQuotes', userInfo.checkDisplayQuotes);
      localStorage.setItem('wholesalebroker', userInfo.wholeselar);
      localStorage.setItem('canhaveUserBroker', userInfo.canhaveUserBroker);
      localStorage.setItem('userAgencyName', userInfo.userData.u_agency_name);
      localStorage.setItem('u_email', userInfo.userData.u_email);
      localStorage.setItem('u_name', userInfo.userData.u_name);
      localStorage.setItem('u_login_id', userInfo.userData.u_login_id);
      localStorage.setItem('u_first_name', userInfo.userData.u_first_name);
      localStorage.setItem('u_last_name', userInfo.userData.u_last_name);
      localStorage.setItem('qu_id', userInfo.userData.qu_id);
      localStorage.setItem('hasRenewal', userInfo.hasRenewal);
      localStorage.setItem('renewalQuotesList', '0');
      localStorage.setItem('expiredQuotesList', '0');

      if(userInfo.isChieldAndCreatedBroker == 1)
      {
        localStorage.setItem('loggedBrokerIsChield', '1');
      }
      else
      {
        localStorage.setItem('loggedBrokerIsChield', '0');
      }

      this.dataService.changeCurrentHeaderDisplayName(userInfo.userData.u_email);
      this.dataService.changeCurrentLoggedStatus('1');
      this.dataService.currentLoggedStatus.subscribe(status => this.loggedStatus = status);

      if (typeof localStorage.getItem('previous_page') != 'undefined' && localStorage.getItem('previous_page') != null && localStorage.getItem('previous_page') != 'null' && localStorage.getItem('previous_page') != "") {
        let previousPageUrl = localStorage.getItem('previous_page');
        localStorage.setItem('active_tab', '2');
        this.dataService.changeCurrentHeaderActive('2');
        this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
        localStorage.removeItem('previous_page');
        this.router.navigate(['/' + previousPageUrl]);
      }
      else {
        if (userInfo.userData.u_ur_id != 4 && userInfo.userData.u_ur_id != 3 && userInfo.userData.u_ur_id != 5 && userInfo.userData.u_ur_id != 6) {
          localStorage.setItem('active_tab', '2');
          this.dataService.changeCurrentHeaderActive('2');
          this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
          this.router.navigate(['/quotes']);
        } else if (userInfo.userData.u_ur_id == 3 || userInfo.userData.u_ur_id == 5 || userInfo.userData.u_ur_id == 6) {
          localStorage.setItem('active_tab', '2');
          this.dataService.changeCurrentHeaderActive('2');
          this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
          localStorage.setItem('brokerViewId', userInfo.userData.u_id);
          if(userInfo.wholeselar == 1 || userInfo.canhaveUserBroker == '1' || userInfo.checkDisplayQuotes == '1'){
            this.router.navigate(['/wbroker-quotes']);
          }else{
            this.router.navigate(['/broker-quotes']);
          }
          
        } else {
          localStorage.setItem('active_tab', '0');
          this.dataService.changeCurrentHeaderActive('0');
          this.dataService.currentHeaderActive.subscribe(status => this.activeMenu = status);
          localStorage.setItem('new_quote_id', '2');
          localStorage.setItem('qu_id', userInfo.userData.qu_id);
          this.router.navigate(['/quote-summary', userInfo.userData.qu_id]);
        }
      }
    }
    this.spinner.hide();
  }
  loginRemember(e) {
    if (e.target.checked) {
      localStorage.setItem('loginUserName', this.loginForm.value.u_email);
      localStorage.setItem('loginPassword', this.loginForm.value.u_password);
      localStorage.setItem('loginRememberme', '1');
    } else {
      localStorage.setItem('loginUserName', '');
      localStorage.setItem('loginPassword', '');
      localStorage.setItem('loginRememberme', '0');
    }
  }

}
